import { ACTION_TYPES } from 'Constants'

export const triggerHeaderProfile = (payload) => ({
  type: ACTION_TYPES.PROFILE_SETTINGS,
  payload,
})

export const profiledetails = (payload) => { // Log before returning the action
// console.log('payload-->',payload);
  return {
    type: ACTION_TYPES.PROFILE_DETAILS,
    payload,
  };
};
